module.exports = __webpack_public_path__ + "img/FüKomKW.05fbfc68.svg";